module.exports = __webpack_public_path__ + "img/couponY_en.35c98015.png";